<template>
<div class="publicViewClass" style="padding-top:0">
    <div class="app-inner paperJk">
     <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            返回
            </div>
            </div>
            <div class="tit flex align-cen">
                试卷名称：{{pageInfo.paperName}} | 考试时间：限制{{pageInfo.timeLimit}}分钟
            </div>
        <!-- type切换 -->
        <div class="status-list flex align-cen">
                        <div class="status-list-item " @click="getResultList(1,true)" :class="{'active':isActive == 1}">
                <div class="circle">
                 <div class="message">
                <div class="num">{{pageInfo.examinedNum}}</div>
                <div class="title">已考完</div>
            </div>
                </div>
            </div>
            <div class="status-list-item" @click="getResultList(0,true)" :class="{'active':isActive == 0}">
                <div class="circle">
                    <div class="message">
                        <div class="num">{{pageInfo.examiningNum}}</div>
                        <div class="title">正在考</div>
                    </div>
                </div>
            </div>
             <div class="status-list-item " @click="getResultList1(2,true)" :class="{'active':isActive == 2}">
                <div class="circle">
                 <div class="message">
                <div class="num">{{pageInfo.missExamNum}}</div>
                <div class="title">缺考</div>
            </div>
                </div>
            </div>
        </div>
        <div class="tabbable-custom">
             <div class="rdsdiv"></div>
              <div class="businessList-container-table" style="margin-top:16px;margin-bottom:50px" v-if="isActive == 0 || isActive == 1">
           <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :key="123"
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
         <!-- <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column> -->
            <el-table-column  label="序号" align="center" width="55">
            <template slot-scope="scope">
              <div >{{scope.$index + 1}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="examiner" label="姓名" align="center">
          </el-table-column>
            <el-table-column prop="businessName" label="所属公司" align="center" width="250">
          </el-table-column>
        <el-table-column  label="名次" align="center" v-if="isActive == 1">
           <template slot-scope="scope">
              <div  v-if="isActive == 1">{{scope.row.result}}</div>
            </template>
          </el-table-column> 
            <el-table-column prop="userScore" label="得分" align="center" v-if="isActive == 1">
                 <template slot-scope="scope">
                 <div  v-if="isActive == 1">
                    <span  v-if="scope.row.result !=2">{{String(scope.row.userScore)}}</span>
                     <span  v-else>-</span>
                    </div> 
                 </template>
          </el-table-column>
           <el-table-column  label="得分比" align="center" v-if="isActive == 1">
             <template slot-scope="scope">
              <div  v-if="isActive == 1">{{scope.row.scoreRate || '0.00'}}%</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="考试时间" align="center">
             <template slot-scope="scope">
              <div >{{scope.row.startTime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createBy" label="用时" align="center" v-if="isActive == 1">
             <template slot-scope="scope">
              <div  v-if="isActive == 1">{{convertSecondsToMinutes(scope.row.doTime,1)}}</div>
            </template>
          </el-table-column>
          <el-table-column  label="最后活动" align="center" v-if="isActive == 0">
             <template slot-scope="scope">
              <div  v-if="isActive == 0">{{scope.row.startTime}}</div>
            </template>
          </el-table-column>
          <el-table-column  label="完成率" align="center" v-if="isActive == 0">
            <template slot-scope="scope">
              <div  v-if="isActive == 0">{{scope.row.finishRate}}%</div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="200"
            >
              <template slot-scope="scope">
                 <el-button type="text" size="small"  slot="reference" style="color:red" v-if="isActive == 0" @click.stop="subqz(scope.row)">强制交卷</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openTimline(scope.row)" v-if="isActive == 0">监控</el-button>
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="getResulttRanscript(scope.row)" v-if="isActive == 1 && scope.row.result !=2">成绩单</el-button>
                <el-button type="text" size="small"  slot="reference" style="color:red"  @click.stop="getResulttRanscript(scope.row)" v-if="isActive == 1 && scope.row.result ==2">查看</el-button>
                 <!-- <el-button type="text" size="small"  slot="reference" style="color:red"   @click.stop="getGradingPaper(scope.row)" v-if="isActive == 1 && scope.row.result ==2">批卷</el-button> -->
            </template>
          </el-table-column>
          
            </el-table>
             <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
             </div>
                     <div class="businessList-container-table" style="margin-top:16px" v-if="isActive == 2">
                      <el-table
          ref="multipleTable1"
          :data="list1"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable1'
          :key="123"
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
             <el-table-column  label="序号" align="center" width="55">
            <template slot-scope="scope">
              <div >{{scope.$index + 1}}</div>
            </template>
          </el-table-column>
             <el-table-column prop="userName" label="姓名" align="center">
          </el-table-column>
              <el-table-column prop="loginName" label="手机号码" align="center">
            </el-table-column>
                  <el-table-column  label="学员分类" align="center">
                      <template slot-scope="scope">
                        <div class="flex align-cen" style="justify-content:center" v-if="scope.row.traineeClassifyRelationList.length">
                      <div v-for="(item,index) in scope.row.traineeClassifyRelationList"  class="tagbq">
                            {{item.classifyName}}
                        </div>
                        </div>
                        <div v-else>-</div>
                    </template>
            </el-table-column>
                      </el-table>
                       <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
             </div>
        </div>
    </div>
    <!-- 查看成绩单 -->
       <!-- 打开自定义分段 -->
     <el-dialog
  title="查看成绩单"
  :visible.sync="centerDialogVisible"
  width="40%"
  :append-to-body="true"
  center
  custom-class="paperDialogClass publicDialogClass"
  v-if="centerDialogVisible && isActive == 1"
  >
    <el-tabs  v-model="activeName">
        <el-tab-pane label="本次成绩" name="1">
            <div class="print-tab-content">
                <div class="tester-info">
                    <p class="text">{{testerInfo.paperName}}</p>
                    <p class="text">考试者：{{testerInfo.examiner}}</p>
                    <p class="lastP">
                        开始时间：{{testerInfo.startTime}} | 交卷时间：{{testerInfo.answerTime}} 
                    </p>
                    <div class="sorceRow">
                         <div class="result-scores">
                            <div class="exam-record-info" v-if="testerInfo.result !=2">
                                <p class="score-num">{{testerInfo.userScore}}
                                    <span>分</span>
                                </p>
                            </div>
                            <div class="zf"  v-if="testerInfo.result !=2">(总分{{testerInfo.paperScore}}分)</div>
                            <div class="reult2" v-if="testerInfo.result ==2">
                                <div class="reult2_tip">答题已结束，感谢您的参加</div>
                                <div class="reult2_pj">请等待老师批卷，批卷完成后将展示成绩</div>
                            </div>
                             <div class="zf">用时：{{$util.convertSecondsToMinutes(testerInfo.doTime,2)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="答题分析" name="2">
             <div>
    <el-radio-group v-model="radio" @change="getQuestionListCom(radio)">
      <el-radio-button label="1">
        答错（{{testerInfo.wrongNum}}）
      </el-radio-button>
      <el-radio-button label="2">
        得分（{{testerInfo.rightNum}}）
      </el-radio-button>
      <el-radio-button label="3">
        全部步骤（{{testerInfo.stepNum}}）
      </el-radio-button>
    </el-radio-group>
        <div class="watermark">
            <div class="question">
                <div class="question-main-content" v-if="questionList.length">
                       <div class="public-tit flex align-cen" style="margin-bottom:10px">
                      <div class="public-tit-list">
                          <i class="icon-al-database-fill"></i>  过程
                      </div>
                  </div>
                           <el-table
                    :data="processList"
                    border
                    style="width: 100%"
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                        <el-table-column prop="processName" label="过程名称" align="center" >
                        </el-table-column>
                         <el-table-column  label="起始条件"  width="300">
                          <template slot-scope="scope">
                            <div class="flex justify-content-cen">
                              <div v-for="(item,pindex) in scope.row.startCondition" :key="pindex" class="flex ">
                                 <span class="textR">{{item.cond1}}</span>{{item.tag}} {{item.name}}{{item.tj}}{{item.tj1}}
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                          <el-table-column  label="结束条件"  width="300">
                            <template slot-scope="scope">
                            <div class="flex justify-content-cen">
                              <div v-for="(item,pindex) in scope.row.endCondition" :key="pindex" class="flex">
                                <span class="textR">{{item.cond1}}</span>{{item.tag}} {{item.name}}{{item.tj}}{{item.tj1}}
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                </el-table>
                        <div class="public-tit flex align-cen" style="margin:10px 0">
                      <div class="public-tit-list">
                          <i class="icon-al-database-fill"></i>  步骤
                      </div>
                  </div>
                          <el-table
                    :data="questionList"
                    border
                    style="width: 100%"
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                        <el-table-column prop="processName" label="关联过程" align="center" >
                        </el-table-column>
                         <el-table-column  prop="stepName" label="步骤名称" align="center">
                        </el-table-column>
                          <el-table-column  label="得分"  align="center">
                            <template slot-scope="scope">
                             <span class="textR"> {{scope.row.customerScore}}</span> / <span>{{scope.row.score}}</span>
                          </template>
                        </el-table-column>
                </el-table>
                </div>
                <div v-else>
                  <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </div>
  </div>
        </el-tab-pane>
        <el-tab-pane label="后台监考" name="3">
            <div class="actions-list" style="padding:0 10px">
                <el-timeline>
                     <el-timeline-item
                    v-for="(activity, index) in resultLogList"
                    :key="index"
                    :type="'success'"
                    :color="'#36aafd'"
                    :size="'large'"
                    placement="top"
                    :timestamp="activity.createTime">
                    <el-card>
                    <h4>{{activity.operate}}</h4>
                    <p> ip:{{activity.ip}}</p>
                </el-card>
                  
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-tab-pane>
        </el-tabs>
               <div class="info-row flex align-cen">
         <span class="info-col-left flex align-cen"> 
            <i class="icon-al-share"></i>分享
         </span>
         <span class="info-col-right felx align-cen mft">
            <span class="pc-wc-share" @click="sharePaper">
                 <el-tooltip placement="left" class="item" effect="dark" content="查看分享海报" popper-class="silderMenu-tips"  >
                <i class="icon-al-qrcode"></i>
                 </el-tooltip>
            </span>
                
             <span class="pc-wc-share" @click="copyLink">
                <el-tooltip placement="left" class="item" effect="dark" content="复制链接" popper-class="silderMenu-tips"  >
                <i class="icon-al-link"></i>
                  </el-tooltip>
            </span>
         </span>
        </div>
      </el-dialog>
        <el-dialog
  title="监控"
  :visible.sync="centerDialogVisible1"
  width="40%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible1 && isActive == 0"
  >
      <div class="actions-list" style="padding:0 10px">
                <el-timeline>
                     <el-timeline-item
                    v-for="(activity, index) in resultLogList1"
                    :key="index"
                    :type="'success'"
                    :color="'#36aafd'"
                    :size="'large'"
                    placement="top"
                    :timestamp="activity.createTime">
                    <el-card>
                    <h4>{{activity.operate}}</h4>
                    <p> ip:{{activity.ip}}</p>
                </el-card>
                  
                    </el-timeline-item>
                </el-timeline>
            </div>
            </el-dialog>
                    <el-dialog
  title="分享成绩单"
  :visible.sync="centerDialogVisible2"
  width="440px"
  :append-to-body="true"
  center>
    <posterDraw :propImg="propImg" :propText="propText" :propQrcode="link" :dowloadImgName="dowloadImgName" ref="posterEmit"></posterDraw>
</el-dialog>
    </div>
</template>
<script>
import {rasoResultList,rasoResulttRanscript,rasMonitor,rasoMissExamPage,rasoResultMonitorLog,rasoForceSubmit} from '@/api/enterprise/index' // 考试记录分页、查看成绩单、基本信息
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import questionList from "@/components/questionList/index.vue"; //分页组件
import mycomponents from "@/utils/compoments.js"
export default {
    components:{
      paginaTion,
      questionList,
      posterDraw:mycomponents.components.posterDraw
    },
    data() {
        return {
             stepList:[],
          processList:[],
            propData:{},
            propImg:'https://oss.yhkz.com/2024-05-25/%E6%88%91%E7%9A%84%E8%80%83%E8%AF%95%20(2)_20240525134806.jpg',
            propText:'',
            link:'',
            centerDialogVisible2:false,
            dowloadImgName:'成绩单',
            posterImg:'',
            pageInfo:{},
            resultLogList:[],
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            resultQuestionVOList:[],
            questionList:[],
            radio:'1',
            activeName:'1',
            centerDialogVisible:false,
            isSwitch:false,
            isActive:1,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            list:[], 
            list1:[], 
            multipleSelection:[],
            testerInfo:{},
            resultLogList1:[],
            centerDialogVisible1:false,
            businessInfo:{}
        }
    },
    created () {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getMonitor()
        this.getResultList(1)
    },
    methods: {
      reback(){
        if(this.$route.query.type == 1){
          this.$util.reback('/teacheManage/enSimulationPaper')
        }else if(this.$route.query.type == 2){
          this.$util.reback('/teacheManage/dashboard')
        }else{
          
        }
      },
           // 强制交卷
        subqz(data){
             let bfb = Number(data.finishRate)
               this.$confirm(`我们建议只强制提交完成率为80%以上的试卷,当前完成率为${bfb}%，是否继续交卷？`, '温馨提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        rasoForceSubmit({id:data.id}).then(res => {
                             this.$message.success('强制交卷成功'); 
                            this.getMonitor()
                             this.getResultList(0)
                            })
                        }).catch(() => {          
                        });
        },
          // 打开监控
        openTimline(data){
            this.centerDialogVisible1 = true
            rasoResultMonitorLog({id:data.id}).then(res => {
              this.resultLogList1 = res.data
            })
        },
        format(percentage){
            return this.testerInfo.userScore || 0 
        },
        format1(){
            return Number(testerInfo.userScore / testerInfo.paperScore) * 100
        },
        // 获取考试监控基本信息
        getMonitor(){
            rasMonitor({id:this.$route.query.id,businessId:this.businessInfo.id,practiceMode:'0'})
            .then(res =>{
               this.pageInfo = res.data
            }) 
        },
        copyLink(){
     let _self = this
      this.$copyText(this.link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
        },
        sharePaper(){
            this.centerDialogVisible2 = true
              this.$nextTick(() => {
                 this.$refs.posterEmit.handleChangeImg(this.propData) 
              })
           
        },
        // 获取成绩单
        getResulttRanscript(data){
            this.centerDialogVisible = true
            this.activeName = '1'
             this.radio = '1'
           this.processList = []
            this.stepList = []
            this.questionList = []
            rasoResulttRanscript({id:data.id}).then(res => {
                this.propData = data
                this.testerInfo = res.data
                this.resultQuestionVOList = res.data.resultQuestionVOList
                this.resultLogList = res.data.resultLogList
                this.propText =  `考生：${data.examiner}`
                this.dowloadImgName = data.examiner
                this.link = this.$config.prUrl + '#/myExam/transcriptExam?resultId=' + data.id + '&type=2'
                let newarr = ['startCondition','endCondition']
                this.processList = res.data.processList
                this.processList.forEach(item =>{ 
                newarr.forEach((t,index) =>{
                let str = item[t]
                    let arr = []
                    str = str.trim().replace(/;$/, '');  
                    arr = str.split(';')
                   item[t] = arr.map(item =>{
                        // 分割字符串为数组，
                        let parts = item.split(',');
                        // 构造对象  
                            return {  
                                cond1: parts[0],  
                                tag: parts[1],  
                                name: parts[2],  
                                tj: parts[3],  
                                tj1: parts[4]  
                            };
                    })
                    })
                })
                this.stepList = res.data.stepList
                this.getQuestionListCom(1)
            })
        },
           getQuestionListCom(type){
            this.questionList = []
          if(type == 1){
            for (let  key in this.stepList) {
           if(this.stepList[key].stepState != 11){
                this.questionList.push(this.stepList[key])
             }
            }
        }else if(type == 2){
             for (let  key in this.stepList) {
           if(this.stepList[key].stepState == 11){
                this.questionList.push(this.stepList[key])
             }
            }
        }else if(type == 3){
                this.questionList = this.stepList
             }else{
                this.questionList = []
             }
        },
          emitFun(val,val1){
       if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
        if(this.isActive == 0 || this.isActive == 1){
            this.getResultList(this.isActive, false)
        }else{
            this.getResultList1(this.isActive, false) 
        }
      },
        convertSecondsToMinutes(seconds,type){
            if(seconds >0){
               let hours = Math.floor(seconds / 3600);  
                let minutes = Math.floor((seconds % 3600) / 60);  
                let remainingSeconds = seconds % 60; 
                if(type == 1){
                 return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');  
                }else{
                    let hoursText = hours > 0 ? hours.toString().padStart(2, '0') + '时' : ''
                     return  hoursText + minutes.toString().padStart(2, '0') + '分' + remainingSeconds.toString().padStart(2, '0') + '秒';  
                }
            }else{
                return 0
            }
        },
          getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    //   获取考试记录
        getResultList(type,isSwitch){
            this.isActive = type
            this.isSwitch = isSwitch
            if(isSwitch){
                this.currentPage = 1
                this.PageSize = 10
            }
            let params = {
                 businessId:this.businessInfo.id,
                current: this.currentPage,
                size:this.PageSize,
                state:type,
                id:this.$route.query.id,
                practiceMode:'0',
                result:'',
                examiner:'',
                examinerPhone:'',
                startTimeStart:'',
                startTimeEnd:''
            }
            rasoResultList(params).then(res=>{
                this.list = res.data.records || []
             this.totalCount = res.data.total;
            })
        },
             // 缺考
         getResultList1(type,isSwitch){
             this.isActive = type
            this.isSwitch = isSwitch
             if(isSwitch){
                this.currentPage = 1
                this.PageSize = 10
            }
             let params = {
                businessId:this.businessInfo.id,
                current: this.currentPage,
                size:this.PageSize,
                id:this.$route.query.id,
            }
            rasoMissExamPage(params).then(res=>{
                this.list1 = res.data.records || []
             this.totalCount = res.data.total || 0;
            })
         }
    }
}
</script>
<style lang="scss" scoped>
.print-tab-content{
    margin-top: 20px;
    .tester-info{
        text-align: center;
        .text{
            margin-bottom: 0px;
            font-size: 20px;
            color: #333;
        }
        .lastP{
            font-size: 14px;
            color: #999;
        }
        .sorceRow{
            margin: 20px  0 10px 0;
            .reult2{
                .reult2_pj{
                    font-size:13px;
                    color: #999;
                }
            }
            .exam-record-info{
                flex-grow: 1;
                .score-num{
                   color: #333;
                   font-size: 50px;
                   position: relative;
                   font-weight: bold;
                   span{
                    font-size: 14px;
                    
                   }
                //    .UserNum{
                //     position: absolute;
                //     top: 0; 
                //     right: 0;
                //     .pbot{
                //         font-size: 14px;
                //     }
                //    }
                }
            }
        }
    }
}
.watermark{
    .question{
        margin-top: 50px;
        .question-main-content{
            .row{
                .ques-title{
                    vertical-align: middle;
                    -webkit-margin-before: 0;
                    -webkit-margin-after: 0;
                    word-break: break-word; 
                   .ques-number,.ques-type{
                    color: #36aafd;
                   } 
                   .ques-score{
                    color: #aeaeae;
                   }
                }
                .ques-answers{
                    margin-top: 15px;
                    .test_result{
                        justify-content: space-between;
                        .userAnswer{
                            color: #666;
                            min-width: 100px;
                            .true{
                                color: green;
                                font-size: 16px;
                            }
                            .false{
                                color: red;
                                font-size: 16px;
                            }
                        }
                        .score{
                            min-width: 50px;
                            margin-left: 20px;
                        }
                        .dnl{
                            span{
                               color: #36aafd
                            }
                        }
                    }
                }
                .jx{
                    color: #999;
                        padding-top: 10px;
                }
            }
        }
    }
}
.paperJk{
    position: relative;
    .status-list{
    opacity: 1;
    transform: translateY(0px);
    visibility: visible;
    .status-list-item{
    position: relative;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    cursor: pointer;
    -webkit-transition: all .5s;
    transition: all .5s;
    .circle{
      position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 135px;
    height: 135px;
    border-radius: 25px !important;
    }
    .message{
       position: relative;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 110px;
    height: 110px;
    background-color: #fff;
    -webkit-box-shadow: 0 0 10px 0 rgba(15,51,117,.1);
    box-shadow: 0 0 10px 0 rgba(15,51,117,.1);
    border-radius: 50%;
    margin: 10px auto;
    .num{
        font-size: 18px;
        color: #333;
    }
    .title{
    position: relative;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #999;
    }
    }
    }
    .status-list-item::after{
    content: "";
    position: absolute;
    bottom: 4px;
    left: 50%;
    width: 34px;
    height: 17px;
    -webkit-transform: translate(-50%,100%);
    transform: translate(-50%,100%);
    background-color: transparent;
    -webkit-clip-path: polygon(0 0,100% 0,50% 100%);
    clip-path: polygon(0 0,100% 0,50% 100%);
    -webkit-transition: all .5s;
    transition: all .5s;
    }
    }
    .active{
    background-color: #eaf6ff;
    border-color: #36aafd;
    .message{
      background-color: #36aafd !important;
      .title,.num{
        color: #fff !important;
      }
    }
    }

        .active::after{
                background-color: #eaf6ff !important;
        }
        .tabbable-custom{
            .rdsdiv{
           height: 20px;
        background: #f7f8fa;
        margin-left: -16px;
        margin-top: 30px;
        width: calc(100% + 32px);
            }
        }
}
::v-deep{
   
    .el-progress__text{
      font-weight: bold;
    font-size: 48px !important;
    color: rgb(231, 58, 48) !important
    }
         .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>